import {useQuery} from "@tanstack/react-query"
import {studentPaymentService} from "services"
import {StudentRecurringPayment} from "types/student-account/student-payment"

const queryCacheKey = "student-recurring-payments"
const INITIAL_DATA: StudentRecurringPayment[] = []

export const useStudentRecurringPayments = ({profileId}: {profileId: number}) => {
    const query = useQuery(
        [queryCacheKey, profileId],
        async () => await studentPaymentService.getStudentRecurringPayments(profileId),
        {enabled: !!profileId}
    )

    return {
        recurringPayments: query.data ?? INITIAL_DATA,
        isLoading: query.isFetching,
        refetch: query.refetch
    }
}
